import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./SetupGuideBanner.css";

const STEP_MESSAGES = {
  speak_to_lead: {
    emoji: "📞",
    label: "Setup Guide — Step 1",
    text: "Pick any lead below and click Call to make your first AI-powered call!",
  },
  import_db: {
    emoji: "🗄️",
    label: "Setup Guide — Step 2",
    text: "Import your existing database here. Supports CSV, Excel, Google Contacts, HubSpot & Zoho.",
  },
  import_leads: {
    emoji: "👥",
    label: "Setup Guide — Step 3",
    text: "The Import window has opened — map your columns and upload your lead list!",
  },
  setup_whatsapp: {
    emoji: "💬",
    label: "Setup Guide — Step 4",
    text: "Connect your WhatsApp Business account below to start messaging leads directly.",
  },
  setup_email: {
    emoji: "📧",
    label: "Setup Guide — Step 5",
    text: "The Email Integrations section is highlighted below — connect Gmail, Outlook or SMTP.",
  },
  connect_crm: {
    emoji: "🔌",
    label: "Setup Guide — Step 6",
    text: "The CRM Integrations section is highlighted below — sync HubSpot, Zoho or Pipedrive.",
  },
};

const SetupGuideBanner = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [step, setStep] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const fromSetup = params.get("fromSetup");

    if (fromSetup && STEP_MESSAGES[fromSetup]) {
      if (timerRef.current) clearTimeout(timerRef.current);
      setLeaving(false);
      setStep(fromSetup);
      setVisible(true);

      // Fade out after 3 s
      timerRef.current = setTimeout(() => {
        setLeaving(true);
        setTimeout(() => setVisible(false), 400);
      }, 3000);
    } else {
      setVisible(false);
      setStep(null);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [location.search]);

  if (!visible || !step) return null;

  const msg = STEP_MESSAGES[step];

  return (
    <div className={`sgb-banner${leaving ? " sgb-banner--out" : ""}`}>
      <div className="sgb-inner">
        <div className="sgb-accent" />
        <span className="sgb-emoji">{msg.emoji}</span>
        <div className="sgb-content">
          <span className="sgb-label">{msg.label}</span>
          <div className="sgb-text">{msg.text}</div>
        </div>
        <button
          className="sgb-close"
          onClick={() => {
            setLeaving(true);
            setTimeout(() => setVisible(false), 400);
          }}
          title="Close"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default SetupGuideBanner;
